import {Directive, HostListener, input, OnDestroy, OnInit, output} from '@angular/core';
import {Subject, Subscription} from 'rxjs';
import {debounceTime} from 'rxjs/operators';

@Directive({
    selector: '[appDebounceKeyup]'
})
export class DebounceKeyupDirective implements OnInit, OnDestroy {

    debounceTime = input(500);
    debounceKeyup = output<any>();

    private keyup = new Subject();
    private subscription$!: Subscription;

    ngOnInit(): void {
        this.subscription$ = this.keyup.pipe(debounceTime(this.debounceTime())).subscribe(e => this.debounceKeyup.emit(e));
    }

    ngOnDestroy(): void {
        this.subscription$?.unsubscribe();
    }

    @HostListener('keyup', ['$event'])
    clickEvent(event: any): void {
        event.preventDefault();
        event.stopPropagation();
        this.keyup.next(event);
    }
}
